"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("@nerdwallet/marketplace/selectors/common");
var _default = function _default(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    // there's no Software impression event, so don't log impressions
    logImpression: false,
    text: (0, _common.getCtaText)(marketplaceEntity) || 'Shop Now'
  };
};
exports.default = _default;